import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-responsive-dt";
import $ from "jquery";
import Modal from "react-modal";
import {
  assignRole_User,
  fetchEvaluadores,
  updatePassword,
} from "../../services/admin";
import {
  asignarEvaluadoresSolicitud,
  changeSolicitudGanador,
  fetchSolicitudes,
} from "../../services/solicitud";
import { assign_evaluador } from "../../services/admin";
import { fetchUsers } from "../../services/admin";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { env } from "../../env";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  Button,
  ContenedorTabla,
  ContentWrap,
  CustomDialog,
  Div,
  EstadoCell,
  PageContainer,
  RowButton,
  StyledLink,
  Tab,
  TabContent,
  Title,
} from "./FeedAdminStyle";

const FeedAdmin = () => {
  const [changes, setChanges] = useState({});
  const [changesRol, setChangesRol] = useState({});
  const [evaluadores, setEvaluadores] = useState([]);
  const [users, setUsers] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("postulacionesSinAsignar");
  const isTableInitialized = useRef({
    table_id: false,
    table_evaluadores: false,
  });
  const user = JSON.parse(sessionStorage.getItem("userData"));
  const tokenData = sessionStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const openModal = async (user) => {
    setSelectedUser(user);
    var password = generatePassword(12);

    setPasswordChanged(password);
    setModalIsOpen(true);
  };

  function generatePassword(length = 12) {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialChars = "!@#$%^&*()_+~`|}{[]:;?><,./-=";

    const allChars = uppercase + lowercase + numbers + specialChars;

    let password = "";
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += specialChars[Math.floor(Math.random() * specialChars.length)];

    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    return password;
  }

  const assignNewPassword = (postulante) => {
    updatePassword(postulante, passwordChanged).then((response) => {
      console.log(response);
      if (response.status === 200) {
        alert("Contraseña reiniciada correctamente");
        closeModal();
      } else {
        alert("Error al reiniciar contraseña");
      }
    });
  };

  const closeModal = async () => {
    setModalIsOpen(false);
    setSelectedUser(null);
  };

  useEffect(() => {
    if (user.rol === "Postulante") {
      window.location.href = "/feedPostulante";
    } else if (user.rol === "Evaluador") {
      window.location.href = "/feedEvaluador";
    }

    const fetchData = async () => {
      try {
        const usersResponse = await fetchUsers(tokenData);
        const usersData = usersResponse.map((element) => ({
          id: element.rut_usuario,
          nombre: `${element.nombre_usuario} ${element.apellido_usuario}`,
          correo: element.correo_usuario,
          rol: element.rol,
        }));

        setUsers(usersData);

        const evaluadoresResponse = await fetchEvaluadores(tokenData);
        const evaluadoresData = evaluadoresResponse.map((element) => ({
          id_user: element.ID_USER,
          id: element.rut_usuario,
          nombre: `${element.nombre_usuario} ${element.apellido_usuario}`,
        }));

        setEvaluadores(evaluadoresData);

        const solicitudesResponse = await fetchSolicitudes();
        const solicitudesData = solicitudesResponse.map((element) => ({
          id: element.id_solicitud,
          nombre: element.nombre_organizacion,
          fondo: element.Nombre_postulacion,
          comuna: element.descripcion_comuna,
          region: element.descripcion_region,
          fechaPostulacion: element.Fecha_Postulacion,
          evaluador: evaluadoresData.find(
            (evalu) => evalu.id === element.rut_evaluador
          )?.nombre,
          evaluador_rut: element.rut_evaluador,
          estado: element.estado_solicitud,
          Puntaje: element.Puntaje ? element.Puntaje : "Sin evaluar",
          ganado: element.ganado,
          evaluadores: element.evaluadores,
        }));

        setSolicitudes(solicitudesData);
        setDataLoaded(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData().finally(() => setIsLoading(false));
  }, [tokenData]);

  useEffect(() => {
    if (dataLoaded) {
      // Destruir tablas existentes antes de inicializar
      if ($.fn.DataTable.isDataTable("#table_id")) {
        $("#table_id").DataTable().destroy();
      }
      if ($.fn.DataTable.isDataTable("#table_evaluadores")) {
        $("#table_evaluadores").DataTable().destroy();
      }

      // Inicializar solo la tabla activa
      if (activeTab === "postulacionesSinAsignar") {
        $("#table_id").DataTable({
          responsive: true,
          columnDefs: [
            { responsivePriority: 1, targets: 0 },
            { responsivePriority: 2, targets: -4 },
            { responsivePriority: 3, targets: -3 },
            { responsivePriority: 4, targets: -1 },
            { responsivePriority: 5, targets: 4 },
          ],
          order: [[3, "asc"]],
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron registros",
            sEmptyTable: "No hay datos disponibles",
            sInfo:
              "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            sInfoEmpty:
              "Mostrando registros del 0 al 0 de un total de 0 registros",
            sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
            sSearch: "Buscar:",
            sLoadingRecords: "Cargando...",
            oAria: {
              sSortAscending:
                ": Activar para ordenar la columna de manera ascendente",
              sSortDescending:
                ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
        isTableInitialized.current.table_id = true;
      } else if (activeTab === "adminCuentas") {
        $("#table_evaluadores").DataTable({
          responsive: true,
          columnDefs: [{ responsivePriority: 0, targets: 0 }],
          order: [[0, "asc"]],
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron registros",
            sEmptyTable: "No hay datos disponibles",
            sInfo:
              "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            sInfoEmpty:
              "Mostrando registros del 0 al 0 de un total de 0 registros",
            sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
            sSearch: "Buscar:",
            sLoadingRecords: "Cargando...",
            oAria: {
              sSortAscending:
                ": Activar para ordenar la columna de manera ascendente",
              sSortDescending:
                ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
        isTableInitialized.current.table_evaluadores = true;
      }
    }
  }, [dataLoaded, activeTab]);

  const handleSelectChange = (id, newEvaluador, x) => {
    if (x == 1) {
      setChanges((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          id_solicitud: id,
          evaluador: newEvaluador,
        },
      }));
    } else {
      setChangesRol((prev) => ({
        ...prev,
        [id]: {
          rut_evaluador: id,
          rol: newEvaluador,
        },
      }));
    }
  };

  const assignEvaluadorSolicitud = (rut, id) => {
    const data = {
      rut_evaluador: rut,
      id_solicitud: id,
    };
    assign_evaluador(data).then((response) => {});
  };

  const assignRolToUser = (rut, rol) => {
    const data = {
      rut_usuario: rut,
      rol: rol,
    };
    assignRole_User(data, tokenData).then((response) => {});
  };

  const handleAssign = () => {
    const changesArray = Object.values(changes);
    changesArray.forEach((element) => {
      assignEvaluadorSolicitud(element.evaluador, element.id_solicitud);
    });
    alert("Evaluadores asignados correctamente");
    window.location.reload();
  };

  const handleRoleAssign = () => {
    const changesArray = Object.values(changesRol);
    changesArray.forEach((element) => {
      assignRolToUser(element.rut_evaluador, element.rol);
    });
    alert("Roles asignados correctamente");
    window.location.reload();
  };

  const changeGanador = async (id, isGanador) => {
    const token = sessionStorage.getItem("token");
    setSolicitudes((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, ganado: isGanador } : item
      )
    );

    const request = changeSolicitudGanador(token, id, isGanador);
    toast.promise(request, {
      pending: "Guardando estado de ganador...",
      success: "Solicitud actualizada",
      error: "Ocurrió un error al guardar",
    });
  };

  const getUrl = (id) => {
    const url = `${env.apiUrl}/solicitud/${id}/descargar-pdf`;
    return url;
  };

  const descargarExcel = () => {
    const token = sessionStorage.getItem("token");
    const url = `${env.apiUrl}/solicitud/reporte/excel?auth=${token}`;
    window.open(url, "_blank");
  };

  const openDialog = (id) => {
    const solicitud = solicitudes.find((solicitud) => solicitud.id === id);
    const evaluadores = solicitud.evaluadores;
    const dialog = document.getElementById("dialog-" + id);
    const checkboxes = dialog.querySelectorAll('input[type="checkbox"]');

    console.log(checkboxes);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    for (const evaluador of evaluadores) {
      const checkbox = document.getElementById(
        "checkbox-" + id + "-" + evaluador.id_evaluador
      );
      if (checkbox) {
        checkbox.checked = true;
      }
    }
    dialog.showModal();
  };

  const guardarEvaluadores = async (id) => {
    const form = document.getElementById("form-ev-" + id);
    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    const selectedEvaluadores = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => parseInt(checkbox.value));

    const token = sessionStorage.getItem("token");

    try {
      const request = asignarEvaluadoresSolicitud(token, id, {
        evaluadores: selectedEvaluadores,
      });

      const nuevosEvaluadores = await toast.promise(request, {
        pending: "Guardando evaluadores...",
        success: "Evaluadores asignados",
        error: "Ocurrió un error al guardar los evaluadores",
      });

      const updatedSolicitudes = [...solicitudes];
      const solicitud = updatedSolicitudes.find(
        (solicitud) => solicitud.id === id
      );
      solicitud.evaluadores = nuevosEvaluadores;
      setSolicitudes(updatedSolicitudes);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.detail,
      });
    }
    const dialog = document.getElementById("dialog-" + id);
    dialog.close();
  };

  return (
    <PageContainer>
      <Navbar name={user.nombre_usuario} />
      <ContentWrap>
        {isLoading ? (
          <Skeleton width="80%" height={80} />
        ) : (
          <Div>
            <Tab
              active={activeTab === "postulacionesSinAsignar"}
              onClick={() => setActiveTab("postulacionesSinAsignar")}
            >
              Postulaciones
            </Tab>

            <Tab
              active={activeTab === "adminCuentas"}
              onClick={() => setActiveTab("adminCuentas")}
            >
              Administrar cuentas
            </Tab>

            {activeTab === "postulacionesSinAsignar" && (
              <TabContent>
                <Title>Lista de solicitudes</Title>
                <Title>
                  <Button onClick={() => descargarExcel()}>
                    Descargar excel
                  </Button>
                </Title>
                <ContenedorTabla>
                  <table
                    id="table_id"
                    className="display responsive nowrap"
                    width="100%"
                  >
                    <thead>
                      <tr>
                        <th>Org. Postulante</th>
                        <th>Fondo</th>
                        <th>Comuna</th>
                        <th>Region</th>
                        <th>Fecha Postulación</th>
                        <th>Postulación</th>
                        <th>Ganador</th>
                        <th>Evaluador</th>
                        <th>Estado</th>
                        <th>Puntaje</th>
                      </tr>
                    </thead>
                    <tbody>
                      {solicitudes.map((postulante) => (
                        <tr key={postulante.id}>
                          <td>
                            <StyledLink
                              to={`/Formulario?id_postulacion=${postulante.id}`}
                            >
                              {postulante.nombre}
                            </StyledLink>
                          </td>
                          <td>{postulante.fondo}</td>
                          <td>{postulante.comuna}</td>
                          <td>{postulante.region}</td>
                          <td>{postulante.fechaPostulacion}</td>
                          <td>
                            <StyledLink
                              to={getUrl(postulante.id)}
                              target="_blank"
                            >
                              Descargar PDF
                            </StyledLink>
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              checked={postulante.ganado || false}
                              onChange={(e) =>
                                changeGanador(postulante.id, e.target.checked)
                              }
                            ></input>
                          </td>
                          <td>
                            <CustomDialog
                              id={"dialog-" + postulante.id}
                              className="dialog"
                            >
                              <p>
                                Asignar evaluadores para la solicitud{" "}
                                <i>{postulante.nombre}</i>
                              </p>
                              <div>
                                <form id={"form-ev-" + postulante.id}>
                                  {evaluadores.map((evaluador) => (
                                    <div key={evaluador.id}>
                                      <input
                                        type="checkbox"
                                        id={
                                          "checkbox-" +
                                          postulante.id +
                                          "-" +
                                          evaluador.id_user
                                        }
                                        value={evaluador.id_user}
                                      />
                                      <label
                                        htmlFor={
                                          "checkbox-" +
                                          postulante.id +
                                          "-" +
                                          evaluador.id_user
                                        }
                                      >
                                        {evaluador.nombre}
                                      </label>
                                    </div>
                                  ))}
                                </form>
                              </div>
                              <div
                                style={{
                                  marginTop: "22px",
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <Button
                                  style={{ backgroundColor: "#ee0000" }}
                                  onClick={() =>
                                    document
                                      .getElementById("dialog-" + postulante.id)
                                      .close()
                                  }
                                >
                                  Cerrar
                                </Button>
                                <Button
                                  onClick={() =>
                                    guardarEvaluadores(postulante.id)
                                  }
                                >
                                  Confirmar
                                </Button>
                              </div>
                            </CustomDialog>
                            <RowButton
                              onClick={() => openDialog(postulante.id)}
                            >
                              Seleccionar evaluadores
                            </RowButton>
                          </td>
                          <EstadoCell estado={postulante.estado}>
                            {postulante.estado}
                          </EstadoCell>
                          <td>{postulante.Puntaje}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </ContenedorTabla>
              </TabContent>
            )}

            {activeTab === "adminCuentas" && (
              <TabContent>
                <Title>
                  Administrar cuentas
                  <Button
                    onClick={handleRoleAssign}
                    disabled={Object.keys(changesRol).length === 0}
                  >
                    Modificar rol
                  </Button>
                </Title>
                <ContenedorTabla>
                  <table
                    id="table_evaluadores"
                    className="display responsive nowrap"
                    width="100%"
                  >
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Correo</th>
                        <th>Rol</th>
                        <th>Reiniciar Contraseña</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((evaluador) => (
                        <tr key={evaluador.id}>
                          <td>{evaluador.nombre}</td>
                          <td>{evaluador.correo}</td>
                          <td>
                            <select
                              value={
                                changesRol[evaluador.id]?.rol || evaluador.rol
                              }
                              onChange={(e) =>
                                handleSelectChange(
                                  evaluador.id,
                                  e.target.value,
                                  2
                                )
                              }
                            >
                              <option value="">Seleccionar rol</option>
                              <option key={1} value={"Postulante"}>
                                Postulante
                              </option>
                              <option key={2} value={"Evaluador"}>
                                Evaluador
                              </option>
                              <option key={3} value={"Administrador"}>
                                Administrador
                              </option>
                            </select>
                          </td>
                          <td>
                            <StyledLink
                              as="button"
                              onClick={() => openModal(evaluador)}
                            >
                              Reiniciar
                            </StyledLink>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    contentLabel="Reiniciar Contraseña"
                    style={{
                      content: {
                        position: "fixed",
                        zIndex: "9999",
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "white",
                        padding: "20px",
                        border: "1px solid #ccc",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                        width: "400px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      },
                      overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: "9998",
                      },
                    }}
                  >
                    <h2>Reiniciar Contraseña</h2>
                    <p>Nueva contraseña: {passwordChanged}</p>
                    {selectedUser && (
                      <p style={{ marginBottom: "50px" }}>
                        ¿Está seguro que desea reiniciar la contraseña para{" "}
                        {selectedUser.correo}?
                      </p>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        position: "absolute",
                        bottom: "20px",
                        left: "20px",
                        right: "20px",
                        marginTop: "50px",
                      }}
                    >
                      <button
                        onClick={(e) => {
                          assignNewPassword(selectedUser.correo);
                        }}
                        style={{ alignSelf: "flex-end" }}
                      >
                        Confirmar
                      </button>
                      <button
                        onClick={closeModal}
                        style={{ alignSelf: "flex-start" }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </Modal>
                </ContenedorTabla>
              </TabContent>
            )}
          </Div>
        )}
      </ContentWrap>
      <Footer />
      <ToastContainer autoClose={3000} />
    </PageContainer>
  );
};

export default FeedAdmin;
